module.exports = __webpack_public_path__ + "img/Anhänger_Netzersatzanlage.3c18d8a1.svg";